import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, Text } from "react-native";
import { connect } from "react-redux";

import fonts from "../constants/fonts";

export const STATIC_CARD_NUMBERS = ["parents", "partner", "children"];

class DependencyDetail extends React.Component {
  static propTypes = {
    cardNumber: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
  };

  render() {
    const { cardNumber, fullName, themeColors } = this.props;

    return (
      <>
        <Text
          numberOfLines={1}
          style={[
            styles.fullName,
            {
              color: themeColors.darkerPrimary,
            },
          ]}
        >
          {fullName}
        </Text>
        {!STATIC_CARD_NUMBERS.includes(cardNumber) && (
          <Text
            style={[
              styles.cardNumber,
              {
                color: themeColors.darkestPrimary,
              },
            ]}
          >
            {cardNumber}
          </Text>
        )}
      </>
    );
  }
}

const styles = StyleSheet.create({
  cardNumber: {
    fontSize: 16,

    ...fonts.regular,
  },
  fullName: {
    fontSize: 20,

    ...fonts.bold,
  },
});

export default connect((state) => ({
  themeColors: state.themeColors,
}))(DependencyDetail);
